export type SubFilterOption = {
  label: string;
  field: 'gameType' | 'brand';
  value: string;
  comingSoon?: boolean;
  isAll?: boolean;
};

const BETMGM_SUB_FILTERS: SubFilterOption[] = [
  { label: 'All Games',          field: 'brand', value: '__all__',           isAll: true },
  { label: 'The Price Is Right', field: 'brand', value: 'The Price Is Right' },
  { label: 'Family Feud',        field: 'brand', value: 'Family Feud' },
  { label: 'Survivor',           field: 'brand', value: 'Survivor' },
  { label: "Let's Make a Deal",  field: 'brand', value: "Let's Make a Deal" },
  { label: 'Big Brother',        field: 'brand', value: 'Big Brother' },
  { label: 'Fear Factor',        field: 'brand', value: 'Fear Factor' },
  { label: 'Traitors',           field: 'brand', value: 'Traitors' },
  { label: 'Money Drop',         field: 'brand', value: 'Money Drop',        comingSoon: true },
];

export const SUB_FILTER_CONFIG: Record<string, SubFilterOption[]> = {
  'jogoglobal::BetMGM':       BETMGM_SUB_FILTERS,
  'jogoglobal-admin::BetMGM': BETMGM_SUB_FILTERS,
};

export function getSubFilters(brandId: string, category: string | null): SubFilterOption[] {
  return SUB_FILTER_CONFIG[`${brandId}::${category}`] || [];
}
